// Task related constants
const SAVE_TASK_DATA = "SAVE_TASK_DATA";
const CREATE_TASK = "CREATE_TASK";
const DELETE_TASK = "DELETE_TASK";
const UPDATE_TASK = "UPDATE_TASK";

export { 
    SAVE_TASK_DATA, 
    CREATE_TASK, 
    DELETE_TASK, 
    UPDATE_TASK
};